import BaseService from "@/app/core/base/BaseService";
import { toast } from "react-toastify";
import { HandleErrors } from "../../util/helpers/ErrorHelper";

export const ShipSmartController = {
    BaseModel: {
        channel_code: 0,
        channel_identifier_number: "string",
        object: "doc",
        type: "simple",
        tax: "sender",
        insurance: true,
        currency_quote: "USD",
        currency_payment: "BRL",
        address_sender: {
            address_code: 0,
            country_code: "string",
            state: "string",
            state_code: "string",
            postal_code: "string",
            city: "string"
        },
        address_receiver: {
            address_code: 0,
            country_code: "string",
            state: "string",
            state_code: "string",
            postal_code: "string",
            city: "string"
        },
        boxes: [
            {
                box_code: 0,
                box_identifier: "string",
                name: "string",
                height: 0,
                width: 0,
                depth: 0,
                weight: 0,
                price: 0
            }
        ],
        items: [
            {
                box_id: 0,
                sku: "string",
                name: "string",
                description: "string",
                country_code: "string",
                hscode: "string",
                weight: 0,
                quantity: 0,
                unit_value: 0
            }
        ]
    },

    Quotation: async function (data, response, error){
        await BaseService(
            {
              method: "POST",
              url: `shipsmart/quotation`,
              data: data,
            },
            (res) => response(res),
            (err) => error !== undefined ? error(err) : toast.error(HandleErrors(err))
        );
    },

    Get: async function (id, level, response, error){
        await BaseService(
            {
              method: "GET",
              url: `shipsmart/quotation/${id}/${level}`,
            },
            (res) => response(res),
            (err) => error !== undefined ? error(err) : toast.error(HandleErrors(err))
        );
    },

    ListBox: async function (response, error){
        await BaseService(
            {
              method: "GET",
              url: `shipsmart/box`,
            },
            (res) => response(res),
            (err) => error !== undefined ? error(err) : toast.error(HandleErrors(err))
        );
    },

    ListItem: async function (response, error){
        await BaseService(
            {
              method: "GET",
              url: `shipsmart/item`,
            },
            (res) => response(res),
            (err) => error !== undefined ? error(err) : toast.error(HandleErrors(err))
        );
    },    
}